import settingTypes from "./setting.types";

export default {
  [settingTypes.FETCH_SETTING_SUCCESS](state, payload) {
    state.type = settingTypes.FETCH_SETTING_SUCCESS;
    state.data = payload.data ;
  },
  [settingTypes.FETCH_SETTING_FAILED](state, payload) {
    state.type = settingTypes.FETCH_SETTING_FAILED;
    state.error = payload.error;
  },
  [settingTypes.FETCH_SETTING_REQUEST](state) {
    state.type = settingTypes.FETCH_SETTING_REQUEST;
    state.error = "";
  },
  [settingTypes.DELETE_SETTING_SUCCESS](state, payload) {
    state.type = settingTypes.DELETE_SETTING_SUCCESS;
    state.deleted = payload.deleted;
  },
  [settingTypes.DELETE_SETTING_FAILED](state, payload) {
    state.type = settingTypes.DELETE_SETTING_FAILED;
    state.error = payload.error;
  },
  [settingTypes.DELETE_SETTING_REQUEST](state) {
    state.type = settingTypes.DELETE_SETTING_REQUEST;
  },
  [settingTypes.UPDATE_SETTING_SUCCESS](state, payload) {
    state.type = settingTypes.UPDATE_SETTING_SUCCESS;
    state.data = payload.data;
  },
  [settingTypes.UPDATE_SETTING_FAILED](state, payload) {
    state.type = settingTypes.UPDATE_SETTING_FAILED;
    state.error = payload.error;
  },
  [settingTypes.UPDATE_SETTING_REQUEST](state) {
    state.type = settingTypes.UPDATE_SETTING_REQUEST;
    state.error = "";
  },

  [settingTypes.ADD_EMPLOYEE_SUCCESS](state, payload) {
    state.type = settingTypes.ADD_EMPLOYEE_SUCCESS;
    state.data = payload.data;
  },
  [settingTypes.ADD_EMPLOYEE_FAILED](state, payload) {
    state.type = settingTypes.ADD_EMPLOYEE_FAILED;
    state.error = payload.error;
  },
  [settingTypes.ADD_EMPLOYEE_REQUEST](state) {
    state.type = settingTypes.ADD_EMPLOYEE_REQUEST;
    state.error = "";
  }
};
